import { render } from "./uploadFileTemplate.vue?vue&type=template&id=907b1572&scoped=true"
import script from "./uploadFileTemplate.vue?vue&type=script&lang=js"
export * from "./uploadFileTemplate.vue?vue&type=script&lang=js"

import "./uploadFileTemplate.vue?vue&type=style&index=0&id=907b1572&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907b1572"],['__file',"src/components/uploadFileTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "907b1572"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('907b1572', __exports__)) {
    api.reload('907b1572', __exports__)
  }
  
  module.hot.accept("./uploadFileTemplate.vue?vue&type=template&id=907b1572&scoped=true", () => {
    api.rerender('907b1572', render)
  })

}


export default __exports__